import React from 'react';
import { STATUS } from './docUtils';

export default function StatusPill({ status, testId }) {
  const s = STATUS[status] || STATUS.draft;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
}
